"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var ExceptionHandler = /** @class */ (function () {
    function ExceptionHandler() {
    }
    ExceptionHandler.prototype.buildExceptionFromErrorMessage = function (title, status, detail, message) {
        var exceptionHandler = new ExceptionHandler();
        var exception = exceptionHandler.buildException(title, status, detail, { error: message });
        return JSON.stringify(exception);
    };
    ExceptionHandler.prototype.buildExceptionFromError = function (error) {
        var data = error.response ? error.response.data : undefined;
        var status = data ? this.parseStatus(data) : 400;
        var title = this.getHttpStatusCodeError(status);
        var detail = title;
        var meta = this.parseError(error);
        return this.buildException(title, status, detail, meta);
    };
    ExceptionHandler.prototype.buildException = function (title, status, detail, meta) {
        var exception = {
            title: title, status: status, detail: detail, meta: meta
        };
        return exception;
    };
    ExceptionHandler.prototype.parseError = function (error) {
        try {
            if (Array.isArray(error)) {
                var errors_1 = '';
                lodash_1.map(error, function (errorValue, index) {
                    errors_1 = errors_1.concat("" + (index === 0 ? '' : '\n') + index + ". " + JSON.stringify(errorValue));
                });
                var metaData = {
                    error: errors_1
                };
                return metaData;
            }
        }
        catch (_a) {
            if (Array.isArray(error)) {
                var metaData = {
                    error: JSON.stringify(error)
                };
                return metaData;
            }
        }
        var data = error.response ? error.response.data : undefined;
        if (data) {
            return this.parseServerError(data);
        }
        else {
            var message = error.message ? error.message : JSON.stringify(error);
            var metaData = {
                error: message
            };
            return metaData;
        }
    };
    ExceptionHandler.prototype.parseServerError = function (data) {
        var EXCEPTION_STRING = 'Exception:';
        try {
            var errorDetails = data.substr(31); // exclude 'Server returned HTTP error 404:' from data
            var index = data.indexOf(EXCEPTION_STRING); // Validation error meta data
            if (index === -1) {
                return { error: data };
            }
            var exceptionIndex = data.indexOf(EXCEPTION_STRING) + EXCEPTION_STRING.length;
            var errorString = data.replace(data.substring(0, exceptionIndex), "");
            if (errorString.replace(/^[ ]+|[ ]+$/g, '') === '') {
                return { error: errorDetails };
            }
            return { error: JSON.parse(errorString) };
        }
        catch (error) {
            return { error: JSON.stringify(data) };
        }
    };
    ExceptionHandler.prototype.parseStatus = function (data) {
        try {
            var errorStatus = data.substring(27, 30); // Get status eg. 404 from 'Server returned HTTP error 404.....'
            var status_1 = parseInt(errorStatus, 10);
            return status_1;
        }
        catch (_a) {
            return NaN;
        }
    };
    ExceptionHandler.prototype.getHttpStatusCodeError = function (status) {
        switch (status) {
            case 400: {
                return 'Error: Bad Request';
            }
            case 401: {
                return 'Error: Unauthorized';
            }
            case 403: {
                return 'Error: Forbidden';
            }
            case 404: {
                return 'Error: Not Found';
            }
            case 409: {
                return 'Error: Conflict';
            }
            case 500: {
                return 'Error: Internal Server Error';
            }
            case 502: {
                return 'Error: Bad Gateway';
            }
            case 503: {
                return 'Error: Service Unavailable';
            }
            default: {
                return 'Error .';
            }
        }
    };
    return ExceptionHandler;
}());
exports.ExceptionHandler = ExceptionHandler;
//# sourceMappingURL=ExceptionHandler.js.map